(() => {
  const hero = document.querySelector('canea-hero-motion');
  if (!hero) return;
  const preference = matchMedia('(prefers-reduced-motion: no-preference)');
  const finePointer = matchMedia('(pointer: fine)');
  const header = document.querySelector('.section-header');
  const pending = new Set();
  document.documentElement.classList.add('canea-motion-page');
  const reveal = element => {
    element.classList.add('is-visible');
    pending.delete(element);
    observer?.unobserve(element);
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) reveal(entry.target); });
  }, {threshold:.08,rootMargin:'0px 0px -32px 0px'}) : null;
  const prepare = (element, index = 0) => {
    if (!element || element.classList.contains('canea-reveal')) return;
    if (!preference.matches || !observer) return;
    const bounds = element.getBoundingClientRect();
    if (bounds.top < innerHeight * .96) return;
    element.style.setProperty('--reveal-delay', `${Math.min(index,3)*110}ms`);
    element.classList.add('canea-reveal');
    pending.add(element);
    observer.observe(element);
  };
  const prepareSections = () => {
    document.querySelectorAll('.canea-section-heading').forEach(el => [...el.children].forEach(prepare));
    document.querySelectorAll('.canea-gammes__grid,.canea-current__track,.canea-footer__top').forEach(el => [...el.children].forEach(prepare));
    document.querySelectorAll('.canea-craft__copy').forEach(el => [...el.children].forEach(prepare));
  };
  let frame = 0;
  const update = () => {
    frame = 0;
    const currentHero = document.querySelector('canea-hero-motion');
    if (!currentHero) return;
    const heroBounds = currentHero.getBoundingClientRect();
    header?.classList.toggle('canea-header--scrolled', heroBounds.top < -100);
    const craft = document.querySelector('.canea-craft');
    if (craft && preference.matches && finePointer.matches) {
      const bounds = craft.getBoundingClientRect();
      if (bounds.bottom > 0 && bounds.top < innerHeight) {
        const progress = Math.max(0,Math.min(1,(innerHeight-bounds.top)/(innerHeight+bounds.height)));
        craft.style.setProperty('--craft-y', `${(progress-.5)*48}px`);
        craft.style.setProperty('--craft-turn', `${progress*45}deg`);
      }
    }
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  document.addEventListener('focusin', event => {
    const element = event.target.closest('.canea-reveal');
    if (element) reveal(element);
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('header-drawer a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const destination = new URL(link.href, location.href);
    if (!destination.hash || destination.origin !== location.origin || destination.pathname !== location.pathname) return;
    const drawer = link.closest('header-drawer');
    const summary = drawer.querySelector('details[open] > summary');
    if (!summary || typeof drawer.closeMenuDrawer !== 'function') return;
    drawer.closeMenuDrawer(event, summary);
    summary.setAttribute('aria-expanded', 'false');
  });
  preference.addEventListener('change', () => {
    if (!preference.matches) {
      [...pending].forEach(reveal);
      document.querySelector('.canea-craft')?.style.removeProperty('--craft-y');
      document.querySelector('.canea-craft')?.style.removeProperty('--craft-turn');
    }
    schedule();
  });
  document.addEventListener('shopify:section:load', () => { prepareSections(); schedule(); });
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  prepareSections();
  update();
})();
